import React from 'react';
import styled from 'styled-components';
import Icon from '@mdi/react';
import {
  mdiOfficeBuilding,
  mdiWarehouse,
  mdiHanger,
  mdiServer,
  mdiFlask,
  mdiHelpBoxOutline,
} from '@mdi/js';
import StoreIcon from '@material-ui/icons/Store';
import SiteType from 'hooks/useSiteInfo/interfaces/SiteType';

const StyledIconContainer = styled.div`
  grid-area: icon;
  display: flex;
  align-items: center;
`;

function renderIcon(siteType: SiteType) {
  switch (siteType) {
    case SiteType.Corporate:
      return <Icon path={mdiOfficeBuilding} size={1} />;
    case SiteType.Headquarters:
      return <Icon path={mdiOfficeBuilding} size={1} />;
    case SiteType.Office:
      return <Icon path={mdiOfficeBuilding} size={1} />;
    case SiteType.DataCenter:
      return <Icon path={mdiServer} size={1} />;
    case SiteType.Gwan:
      return <Icon path={mdiServer} size={1} />;
    case SiteType.Lab:
      return <Icon path={mdiFlask} size={1} />;
    case SiteType.Distribution:
      return <Icon path={mdiWarehouse} size={1} />;
    case SiteType.Retail:
      return <StoreIcon />;
    case SiteType.Showroom:
      return <Icon path={mdiHanger} size={1} />;
    default:
      return <Icon path={mdiHelpBoxOutline} size={1} />;
  }
}

interface SiteIconProps {
  siteType: SiteType;
}

export default function SiteIcon({siteType}: SiteIconProps) {
  return <StyledIconContainer>{renderIcon(siteType)}</StyledIconContainer>;
}
